export default __webpack_public_path__ + "static/kasia-c34d810e91f5b02a3671ae87a4e286ae.jpg";